import { Base2Presenter } from "core/presenter";
import { CustomerRepository, CompanyRepository } from "core/repository";
import { CustomerFields } from "core/enum";

import _ from "lodash";

class CustomerViewPresenter extends Base2Presenter {
  initialState() {
    return {
      customer: null,
      loading: true,
      error: false,
      configCustomFields: [],
      fields: []
    };
  }

  async onStart() {
    const customerUuid = this.routeParams.customerUuid;
    await this.getConfigFields();
    this.loadCustomer(customerUuid);
  }

  async loadCustomer(uuid) {
    this.enqueue({ loading: true, error: false });

    const customerResult = await CustomerRepository.get(uuid);

    if (customerResult.success) {
      this.enqueue({ customer: customerResult.data });
    } else {
      this.enqueue({
        error:
          "Não conseguimos carregar este cliente! Tente novamente em alguns minutos."
      });

      await this.sendNotification({
        type: "error",
        title: "Oops...",
        content: this.viewModel.error
      });
    }

    this.enqueue({ loading: false });
  }

  async getConfigFields() {
    const currentUser = await this.mRuntime.get("currentUser");
    const results = await CompanyRepository.get(currentUser.company_uuid);

    const data = [...results.data.customer_fields, ...CustomerFields];
    const fields = _.uniqBy(data, "key");

    if (results.success) {
      this.enqueue({
        configCustomFields: results.data.customer_custom_fields,
        fields
      });
    }
  }

  onGoBack() {
    this.navigateTo("app.registration.customer");
  }

  onEdit(customer) {
    this.navigateTo("app.registration.customer.edit", {
      customerUuid: customer.uuid
    });
  }

  onRequestDelete(customer) {
    this.sendNotification({
      type: "confirmation",
      title: "Você tem certeza?",
      content: `Tem certeza que deseja excluir o cliente ${customer.identifier()}?`,
      actions: [
        {
          label: "Voltar"
        },
        {
          label: "Sim, quero excluir",
          type: "accent",
          callback: () => this.doDelete(customer)
        }
      ]
    });
  }

  async doDelete(customer) {
    this.enqueue({ loading: true });

    const repositoryResult = await CustomerRepository.delete(customer.uuid);

    if (repositoryResult.success) {
      this.navigateTo("app.registration.customer");
      this.sendNotification({
        type: "success",
        content: "O cliente foi excluído."
      });
    } else if (repositoryResult.fatal) {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content: "Ocorreu um erro na conexão. Tente novamente mais tarde."
      });
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content: repositoryResult.error
      });
    }

    this.enqueue({ loading: false });
  }
}

export default CustomerViewPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/view/presenter.js